import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminEditKonnectTradeRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/konnect/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/admin/LabTrades/Konnect/AdminEditKonnectTradePage/AdminEditKonnectTradePage').then(
    (d) => d.Route
  )
);
